// extracted by mini-css-extract-plugin
export default {"wrapper":"SwippyInputLabelWithCta_wrapper__Ugnd0","title":"SwippyInputLabelWithCta_title__ht+5-"};